import Swiper, { Navigation, Pagination, Autoplay } from "swiper";
import "swiper/css/bundle";
import "swiper/css/pagination";

export default class UI {
    constructor() {
        this.init();
    }

    init() {
        this.swiper();
    }

    swiper() {
        Swiper.use([Navigation, Pagination, Autoplay]);
        const swiper1 = new Swiper(".bnr .swiper-container", {
            // Optional parameters
            slidesPerView: 375 / 335,
            centeredSlides: true,
            loop: true,
            speed: 500,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },

            // Pagination
            pagination: {
                el: ".swiper-pagination",
                type: "bullets",
                clickable: true,
            },

            breakpoints: {
                835: {
                    slidesPerView: (1920 - 86) / 1000,
                },
            },
        });

        // const swiper2 = new Swiper(".top-slider .swiper-container", {
        //     // Optional parameters
        //     slidesPerView: 2,
        //     slidesPerGroup: 2,
        //     // spaceBetween: 12,
        //     loop: true,
        //     speed: 500,

        //     // Navigation arrows
        //     navigation: {
        //         nextEl: '.swiper-button-next',
        //         prevEl: '.swiper-button-prev',
        //     },

        //     // Pagination
        //     pagination: {
        //         el: ".swiper-pagination",
        //         type: "bullets",
        //         clickable: true,
        //     },

        //     breakpoints: {
        //         835: {
        //             slidesPerView: 3,
        //             spaceBetween: 0,
        //             slidesPerGroup: 3,
        //         },
        //         1323: {
        //             slidesPerView: 4,
        //             slidesPerGroup: 4,
        //         },
        //         1606: {
        //             slidesPerView: 5,
        //             slidesPerGroup: 5,
        //         }
        //     }
        // });
    }
}
